import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IFeature } from '../features.interface';
import { FeaturesService } from '../features.service';
import * as _ from 'lodash';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-features-modal',
  templateUrl: './features-modal.component.html',
  styleUrls: ['./features-modal.component.css']
})
export class FeaturesModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  feature!: IFeature;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;

  constructor(
    public _FeaturesService: FeaturesService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    if (this.feature._id) this.getFeature();
    else this.buildForm();
  }

  getFeature() {
    this.loading = true;
    const feature: any = this.feature._id;
    this._FeaturesService.getFeature(feature).subscribe((feature) => {
      this.feature = feature;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      _id: [this.feature._id],
      code: [this.feature.code, [Validators.required]],
      name: [this.feature.name, [Validators.required]],
      isDeleted: [this.feature.isDeleted]
    });
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: IFeature = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    if (this.feature._id) {
      data._id = this.feature._id;
      this._FeaturesService.updateFeature(data).subscribe((feature) => {
        this.dialog.close(feature);
      });
    } else {
      this._FeaturesService.createFeature(data).subscribe((feature) => {
        this.dialog.close(feature);
      });
    }
  }
}